// Shell navigation: one entry per module (icon rail) with its pages (top sub-navigation).
// `packet` gates the whole module, `perm` (entity title) or `super` gates a single page,
// `match` lists the route prefixes that belong to the module so the rail highlights correctly.

export const modules = [
  {
    key: 'dash', label: 'Dashboard', icon: 'home', to: '/dashboard', gradient: 'proj',
    match: ['/dashboard', '/edit-dashboard'],
    pages: [
      { label: 'Dashboard', to: '/dashboard' },
      { label: 'Widgets', to: '/edit-dashboard', perm: 'Dashboard' },
    ],
  },
  {
    key: 'crm', label: 'CRM', icon: 'users', to: '/crm-menu', packet: 'CRM', gradient: 'crm',
    match: ['/crm-menu', '/users', '/service-categories', '/services', '/clients', '/client', '/suppliers', '/supplier', '/contacts', '/contact', '/orphaned-contacts', '/history-changes'],
    pages: [
      { label: 'Clients', to: '/clients', perm: 'Clients', also: ['/client'] },
      { label: 'Suppliers', to: '/suppliers', perm: 'Suppliers', also: ['/supplier'] },
      { label: 'Contacts', to: '/contacts', perm: 'Contacts', also: ['/contact', '/orphaned-contacts'] },
      { label: 'Services', to: '/services', perm: 'Services' },
      { label: 'Service Categories', to: '/service-categories', perm: 'Service Categories' },
      { label: 'Users', to: '/users', perm: 'Users' },
      { label: 'Clients History', to: '/history-changes', super: true },
    ],
  },
  {
    key: 'pm', label: 'Project Management', icon: 'briefcase', to: '/pm-menu', packet: 'PROJECT MANAGEMENT', gradient: 'proj',
    match: ['/pm-menu', '/projects', '/project', '/task', '/subtask', '/hosting', '/host', '/hours', '/follow-up', '/to-do', '/missing-hours', '/hours-requests', '/project-report', '/task-report'],
    pages: [
      { label: 'Projects', to: '/projects', perm: 'Projects', also: ['/project', '/task', '/subtask', '/project-report', '/task-report'] },
      { label: 'Hosting', to: '/hosting', perm: 'Projects', also: ['/host'] },
      { label: 'Hours', to: '/hours', perm: 'Hours', exact: true },
      { label: 'To Do', to: '/to-do' },
      { label: 'Follow up', to: '/follow-up' },
      { label: 'Missing Hours', to: '/missing-hours' },
      { label: 'Hours Requests', to: '/hours-requests', super: true },
    ],
  },
  {
    key: 'hr', label: 'HR', icon: 'heart', to: '/hr-menu', packet: 'HR', gradient: 'hr',
    match: ['/hr-menu', '/days-off', '/holidays', '/other-requests', '/employees', '/employee-profile', '/under-recruitment'],
    pages: [
      { label: 'Days Off', to: '/days-off', perm: 'Days off', exact: true },
      { label: 'Days off Requests', to: '/days-off-requests', super: true },
      { label: 'Other Requests', to: '/other-requests', super: true },
      { label: 'Days Off Reports', to: '/days-off-reports', perm: 'Days off reports' },
      { label: 'Holidays', to: '/holidays', perm: 'Holidays' },
      { label: 'Employees', to: '/employees', perm: 'Users', also: ['/employee-profile', '/under-recruitment'] },
    ],
  },
  {
    key: 'mkt', label: 'Marketing Hub', icon: 'megaphone', to: '/marketing-hub-menu', packet: 'MARKETING HUB', gradient: 'mkt',
    match: ['/marketing-hub-menu', '/lists', '/edit-list', '/list-profile'],
    pages: [
      { label: 'Lists', to: '/lists', perm: 'Lists', also: ['/edit-list', '/list-profile'] },
    ],
  },
  {
    key: 'med', label: 'MED', icon: 'med', to: '/med-menu', packet: 'MED', gradient: 'hr',
    match: ['/med-menu'],
    pages: [],
  },
  {
    key: 'rep', label: 'Reporting & Analytics', icon: 'chart', to: '/reporting-analytics-menu', packet: 'PROJECT MANAGEMENT', gradient: 'files',
    match: ['/reporting-analytics-menu', '/reports'],
    pages: [
      { label: 'Analytics', to: '/reporting-analytics-menu' },
      { label: 'Reports', to: '/reports', perm: 'Reporting' },
    ],
  },
  {
    key: 'files', label: 'File Management', icon: 'folder', to: '/file-management-menu', gradient: 'files',
    match: ['/file-management-menu'],
    pages: [],
  },
];

export const accountModule = {
  key: 'me', label: 'Λογαριασμός', icon: 'user', gradient: 'proj',
  match: ['/change-profile', '/my-permissions', '/notification-settings', '/notifications', '/box-integration'],
  pages: [
    { label: 'Notifications', to: '/notifications', exact: true },
    { label: 'Επεξεργασία λογαριασμού', to: '/change-profile' },
    { label: 'Τα δικαιώματά μου', to: '/my-permissions', notAccountant: true },
    { label: 'Ρυθμίσεις ειδοποιήσεων', to: '/notification-settings', packet: 'PROJECT MANAGEMENT', notAccountant: true },
    { label: 'Box', to: '/box-integration', notAccountant: true },
  ],
};

export const accountantModule = {
  key: 'acc', label: 'Λογιστήριο', icon: 'building', gradient: 'hr',
  match: ['/accountant-dashboard', '/employees-days-off', '/under-recruitment'],
  pages: [
    { label: 'Εταιρείες', to: '/accountant-dashboard' },
    { label: 'Εργαζόμενοι', to: '/employees-days-off' },
    { label: 'Για πρόσληψη', to: '/under-recruitment' },
  ],
};

// '/days-off' also owns '/days-off-requests'; '/host' does not own '/hosting'.
const startsWithSegment = (path, prefix) => path === prefix || ['/', '?', '-'].some((sep) => path.startsWith(prefix + sep));

export function pathMatches(path, prefix, exact) {
  return exact ? path === prefix : startsWithSegment(path, prefix);
}

// Finds the module that owns a route path (longest matching prefix wins, so /projects beats /project).
export function moduleForPath(path, list) {
  let best = null;
  let bestLen = -1;
  for (const mod of list) {
    for (const prefix of mod.match) {
      if (startsWithSegment(path, prefix) && prefix.length > bestLen) {
        best = mod;
        bestLen = prefix.length;
      }
    }
  }
  return best;
}

export function pageIsActive(page, path) {
  if (pathMatches(path, page.to, page.exact)) return true;
  return (page.also || []).some((p) => startsWithSegment(path, p));
}
